'use strict';

var StrategyAllocationAuthAvailActionsController = function StrategyAllocationAuthAvailActionsController($scope, CommonUiConstants) {
  $scope.INT_PATTERN = CommonUiConstants.INT_PATTERN_IGNORE_LEAD_ZERO;
  $scope.STRATEGY_ACTION_CLASS_LINK_VALUE_PATTERN = CommonUiConstants.STRATEGY_ACTION_CLASS_LINK_VALUE_PATTERN;
  $scope.allocationTypeLst = ['...', 'A', 'P'];
  $scope.integerWarning = 'The value must be an integer';
  $scope.classLinkMsg = require('../templates/class-link-validation.html');
  $scope.clearInvalid = function (evt) {
    var el = evt.currentTarget;
    if (!el.validity.valid) {
      this.action[el.name] = null;
    }
  };
};
StrategyAllocationAuthAvailActionsController.$inject = ['$scope', 'CommonUiConstants'];
module.exports = StrategyAllocationAuthAvailActionsController;